import { useState } from "react";
import { useHistory, Link, useLocation } from "react-router-dom";

import DrawerToggle from "./SideDrawer/DrawerToggle";
import SideDrawer from "./SideDrawer";

import { ReactComponent as ArrowUp } from "assets/svgs/chevron-up.svg";
import { ReactComponent as ArrowDown } from "assets/svgs/chevron-down.svg";

import env from "config/envs";

import * as S from "./Header.style";

const conformidadeGovernancaPath = "/conformidade";
const patrociniosPath = "/patrocinios";
const institutoPath = env.HOST_INSTITUTE;
const imprensaPath = "/imprensa";
const cnpAssurancePath = "/cnp-assurances";
const cnpHoldingPath = "/cnp-seguros-holding-brasil";
const culturaCorporativaPath = "/cultura-corporativa";
const canalDeEticaPath = env.HOST_ETICA;
const conquistasPath = "/conquistas";

const Header = () => {
  const history = useHistory();
  const location = useLocation();

  const [showDrawer, setShowDrawer] = useState(false);
  const [showWhoWeAreDropDown, setShowWhoWeAreDropDown] = useState(false);
  const [showOurBusinessDropDown, setShowOurBusinessDropDown] = useState(false);

  const selectedWhoWeAreDropDown = [
    cnpAssurancePath,
    cnpHoldingPath,
    culturaCorporativaPath,
  ].includes(location?.pathname);

  const selectedOurBusinessDropDown = [
    conformidadeGovernancaPath,
    conquistasPath,
    patrociniosPath,
  ].includes(location?.pathname);

  const toggleDropDownHandle = (state, callback) => {
    callback(!state);
  };

  const closeContainers = () => {
    setShowWhoWeAreDropDown(false);
    setShowOurBusinessDropDown(false);
  };

  const toggleWhoWeAreDropDown = () => {
    closeContainers();
    toggleDropDownHandle(showWhoWeAreDropDown, setShowWhoWeAreDropDown);
  };

  const toggleOurBusinessDropDown = () => {
    closeContainers();
    toggleDropDownHandle(showOurBusinessDropDown, setShowOurBusinessDropDown);
  };

  const handleSelectPath = (event, path) => {
    event?.preventDefault();

    closeContainers();
    history.push(path);
  };

  const hidden = (
    <>
      <Link to="/">
        <S.DesktopIcon
          className="make-click"
          data-label="header home logo desktop"
          width={197}
          height={76}
        />
      </Link>
      <S.HeaderItems>
        <S.HeaderItem>
          <S.HeaderLink>
            <S.HeaderText variant="body02-md" color="primary-dark">
              Página inicial
            </S.HeaderText>
          </S.HeaderLink>
        </S.HeaderItem>
      </S.HeaderItems>
    </>
  );

  return (
    <S.Header className="make-section" data-section="header section">
      <S.Nav>
        <S.Wrap>
          <a href="/">
            <S.DesktopIcon
              className="make-click"
              data-label="header home logo desktop"
              width={170}
              height={76}
            />
          </a>

          <S.HeaderItems>
            <S.HeaderItem
              className="make-click"
              data-label="header home link"
              selected={location?.pathname === "/"}
              onClick={(event) => handleSelectPath(event, "/")}
              onMouseEnter={() => closeContainers()}
            >
              <S.HeaderLink>
                <S.HeaderText variant="body02-md" color="primary-dark">
                  Página inicial
                </S.HeaderText>
              </S.HeaderLink>
            </S.HeaderItem>

            <S.HeaderItem
              className="make-click"
              data-label="header sobre a CNP Brasil Link"
              selected={selectedWhoWeAreDropDown}
              onMouseEnter={() => {
                toggleWhoWeAreDropDown();
              }}
            >
              <S.HeaderLink onClick={(e) => e.preventDefault()}>
                <S.HeaderText variant="body02-md" color="primary-dark">
                  Quem somos{" "}
                  {showWhoWeAreDropDown ? <ArrowUp /> : <ArrowDown />}
                </S.HeaderText>
              </S.HeaderLink>
            </S.HeaderItem>

            <S.HeaderItem
              className="make-click"
              data-label="header sobre a CNP Brasil Link"
              selected={selectedOurBusinessDropDown}
              onMouseEnter={() => {
                toggleOurBusinessDropDown();
              }}
            >
              <S.HeaderLink onClick={(e) => e.preventDefault()}>
                <S.HeaderText variant="body02-md" color="primary-dark">
                  Nosso negócio{" "}
                  {showOurBusinessDropDown ? <ArrowUp /> : <ArrowDown />}
                </S.HeaderText>
              </S.HeaderLink>
            </S.HeaderItem>

            <S.HeaderItem
              className="make-click"
              data-label="header instituto link"
              selected={location?.pathname === imprensaPath}
              onClick={(event) => handleSelectPath(event, imprensaPath)}
              onMouseEnter={() => closeContainers()}
            >
              <S.HeaderLink>
                <S.HeaderText variant="body02-md" color="primary-dark">
                  Imprensa
                </S.HeaderText>
              </S.HeaderLink>
            </S.HeaderItem>

            <S.HeaderItem
              className="make-click"
              data-label="header instituto link"
              selected={location?.pathname === institutoPath}
              onClick={() => window.open(institutoPath, "_blank")}
            >
              <S.HeaderLink>
                <S.HeaderText variant="body02-md" color="primary-dark">
                  Instituto
                </S.HeaderText>
              </S.HeaderLink>
            </S.HeaderItem>

            <S.HeaderItem
              className="make-click"
              selected={location?.pathname === canalDeEticaPath}
              onClick={() => window.open(canalDeEticaPath, "_blank")}
            >
              <S.HeaderLink href="/fale-conosco#canal-de-etica">
                <S.HeaderText variant="body02-md" color="primary-dark">
                  Canal de ética
                </S.HeaderText>
              </S.HeaderLink>
            </S.HeaderItem>
          </S.HeaderItems>
        </S.Wrap>

        <S.DropDown
          show={showWhoWeAreDropDown}
          onMouseLeave={() => closeContainers()}
        >
          <S.Flex>
            <S.Hidden>{hidden}</S.Hidden>

            <S.ItemsDropDown>
              <S.HeaderItem
                onClick={(event) => handleSelectPath(event, cnpAssurancePath)}
              >
                <S.HeaderLinkDropDown>
                  <S.TextDropDown variant="body02-md">
                    CNP Assurances
                  </S.TextDropDown>
                </S.HeaderLinkDropDown>
              </S.HeaderItem>

              <S.HeaderItem
                onClick={(event) => handleSelectPath(event, cnpHoldingPath)}
              >
                <S.HeaderLinkDropDown>
                  <S.TextDropDown variant="body02-md">
                    CNP Seguros Holding Brasil
                  </S.TextDropDown>
                </S.HeaderLinkDropDown>
              </S.HeaderItem>

              <S.HeaderItem
                onClick={(event) =>
                  handleSelectPath(event, culturaCorporativaPath)
                }
              >
                <S.HeaderLinkDropDown>
                  <S.TextDropDown variant="body02-md">
                    Cultura Corporativa
                  </S.TextDropDown>
                </S.HeaderLinkDropDown>
              </S.HeaderItem>
            </S.ItemsDropDown>
          </S.Flex>
        </S.DropDown>

        <S.DropDown
          show={showOurBusinessDropDown}
          onMouseLeave={() => closeContainers()}
        >
          <S.Flex>
            <S.Hidden>
              {hidden}
              <S.HeaderItems>
                <S.HeaderItem>
                  <S.HeaderLink>
                    <S.HeaderText variant="body02-md" color="primary-dark">
                      Página inicial
                    </S.HeaderText>
                  </S.HeaderLink>
                </S.HeaderItem>
              </S.HeaderItems>
            </S.Hidden>

            <S.ItemsDropDown>
              <S.HeaderItem
                onClick={(event) =>
                  handleSelectPath(event, conformidadeGovernancaPath)
                }
              >
                <S.HeaderLinkDropDown>
                  <S.TextDropDown variant="body02-md">
                    Conformidade e Governança
                  </S.TextDropDown>
                </S.HeaderLinkDropDown>
              </S.HeaderItem>

              <S.HeaderItem
                onClick={(event) => handleSelectPath(event, patrociniosPath)}
              >
                <S.HeaderLinkDropDown>
                  <S.TextDropDown variant="body02-md">
                    Patrocínios
                  </S.TextDropDown>
                </S.HeaderLinkDropDown>
              </S.HeaderItem>

              <S.HeaderItem
                onClick={(event) => handleSelectPath(event, conquistasPath)}
              >
                <S.HeaderLinkDropDown>
                  <S.TextDropDown variant="body02-md">
                    Conquistas
                  </S.TextDropDown>
                </S.HeaderLinkDropDown>
              </S.HeaderItem>
            </S.ItemsDropDown>
          </S.Flex>
        </S.DropDown>

        <DrawerToggle
          className="make-click"
          data-label="ação de abrir gaveta"
          onCLick={() => setShowDrawer(true)}
        />

        <SideDrawer isOpen={showDrawer} close={() => setShowDrawer(false)} />

        <S.MobileLogoLink to="/">
          <S.Icon
            className="make-click"
            data-label="Ícone CNP link para home"
            heightauto="true"
          />
        </S.MobileLogoLink>
      </S.Nav>
    </S.Header>
  );
};

export default Header;
